import { Routes, Route, Navigate } from "react-router-dom";
import { Suspense, useEffect } from "react";
import { useSelector } from "react-redux";
import React from "react";
import { AppContextProvider } from "./contexts/AppContext";
import { CacheProvider } from "@emotion/react";
import { ThemeProvider } from "@mui/material";
import versionNumber from "./version.txt";
import { theme } from "./data/theme";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import { setupAxios } from "./lib/axios/axios";
import axios from "axios";
import { store } from "./lib/redux/store";
import "./App.css";
import { Loading } from "./components/loading/Loading";
import { Modal } from "./components/modal/Modal";
import Drawer from "./components/drawer/Drawer";
import { Fallback } from "./layouts/fallback/Fallback";
import rtlPlugin from "stylis-plugin-rtl";
import { Header } from "./layouts/header/Header";
import { SidebarContextProvider } from "./contexts/SidebarContext";
import { siteRouting } from "./routes/siteRouting";
import { Box } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { guestRouting } from "./routes/guestRouting";
import { Notif } from "./components/notif/Notif";
import { AdapterDateFnsJalali } from "@mui/x-date-pickers/AdapterDateFnsJalali";

const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const AppRouter = () => {
  const userAuthToken = useSelector((state) => state.userSlice.userAuthToken);

  let routes = [...guestRouting];
  let defaultRoute = "/";

  // const userAuthToken = true;
  // const role = "Poultry";

  if (userAuthToken) {
    routes = [...siteRouting];
  }

  return (
    <Routes>
      {routes?.map((route) => {
        const { exact, Page, props } = route;
        return route.path.map((path) => (
          <Route
            exact={exact}
            path={path}
            key={path}
            element={
              <Suspense fallback={<Fallback />}>
                <Box>
                  <Page {...props} />
                </Box>
              </Suspense>
            }
          />
        ));
      })}
      <Route
        path="*"
        element={<Navigate to={defaultRoute ? defaultRoute : "/"} replace />}
      />
    </Routes>
  );
};

const App = () => {
  const userAuthToken = useSelector((state) => state.userSlice.userAuthToken);

  //buildchange

  useEffect(() => {
    if (window.location.search.includes("refresh")) {
      window.location.href = window.location.pathname;
    }
  }, []);

  const hardRefresh = () => {
    const currentUrl = window.location.href;
    const newUrl = `${currentUrl}?refresh=${new Date().getTime()}`;
    window.location.href = newUrl;
  };

  useEffect(() => {
    if (!window.location.search.includes("autologin")) {
      const uniqueQueryParam = `?v=${new Date().getTime()}`;
      fetch(`${versionNumber}${uniqueQueryParam}`)
        .then((response) => response.text())
        .then((numberText) => {
          const numberFromTxt = numberText.toString();
          const lastVersion = localStorage.getItem("AppVersion");
          console.log("compare versions", numberFromTxt, lastVersion);
          if (
            !lastVersion ||
            lastVersion.toString() !== numberFromTxt.toString()
          ) {
            localStorage.setItem("AppVersion", numberFromTxt.toString());

            if ("caches" in window) {
              caches.keys().then((names) => {
                names.forEach((name) => {
                  caches.delete(name);
                });
              });

              hardRefresh();
            }
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  }, [window.location.pathname]);

  return (
    <CacheProvider value={cacheRtl}>
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDateFnsJalali}>
          <Suspense fallback={<Fallback />}>
            <AppContextProvider>
              <div
                className="App"
                style={
                  {
                    // background: !userAuthToken ? `url("${bg}")` : null,
                    // height: !userAuthToken ? "100vh" : "auto",
                  }
                }
              >
                <div>
                  <SidebarContextProvider>
                    {userAuthToken && <Header />}
                    <Notif />
                  </SidebarContextProvider>
                </div>
                <AppRouter />
              </div>
              <Drawer />
              <Modal />
              <Loading />
            </AppContextProvider>
          </Suspense>
        </LocalizationProvider>
      </ThemeProvider>
    </CacheProvider>
  );
};

setupAxios(axios, store);

export default App;
